import { H1 } from '@payaca/ambrosia';
import IsolatedPurchaseOrderControl from '@/ui/components/isolatedPurchaseOrderControl/IsolatedPurchaseOrderControl';
import AuthenticatedPageWrapper from '@/ui/layouts/authenticatedPageWrapper/AuthenticatedPageWrapper';
import { getHydratedPurchaseOrder } from '@payaca/store/materialsList/materialsListActions';
import {
  HydratedPurchaseOrder,
  PurchaseOrder,
} from '@payaca/types/materialsListTypes';
import { FC, useCallback, useEffect, useState, type JSX } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

type Props = {
  purchaseOrderId: PurchaseOrder['id'];
};

const EditIsolatedPurchaseOrderPage: FC<Props> = ({
  purchaseOrderId,
}: Props): JSX.Element | null => {
  const dispatch = useDispatch();
  const [purchaseOrder, setPurchaseOrder] = useState<HydratedPurchaseOrder>();
  const history = useHistory();

  const getPurchaseOrder = useCallback(() => {
    dispatch(
      getHydratedPurchaseOrder.request({
        purchaseOrderId,
        callback: (purchaseOrder) => {
          setPurchaseOrder(purchaseOrder);
        },
      })
    );
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useCallback has missing dependencies: 'purchaseOrderId', and 'dispatch'
  }, []);

  useEffect(() => {
    getPurchaseOrder();
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'getPurchaseOrder'
  }, []);

  useEffect(() => {
    if (
      !!purchaseOrder &&
      (!purchaseOrder.isIsolated ||
        purchaseOrder.sentAt ||
        purchaseOrder.voidedAt ||
        purchaseOrder.confirmedAt)
    ) {
      history.push(`/purchaseorders/${purchaseOrder?.id}`);
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useEffect has missing dependencies: 'purchaseOrder.id', 'history', 'purchaseOrder.sentAt', 'purchaseOrder.confirmedAt', 'purchaseOrder.voidedAt', and 'purchaseOrder'
  }, [purchaseOrder?.isIsolated]);

  return (
    <AuthenticatedPageWrapper
      breadcrumbItems={[
        {
          label: 'Back',
          to: `/suppliers/${purchaseOrder?.supplierId}?tab=purchase-orders`,
        },
        { label: 'Purchase order' },
      ]}
    >
      <div className="px-8 py-4">
        <H1>{`Purchase order${
          purchaseOrder ? ` for ${purchaseOrder?.supplier.name}` : ''
        }`}</H1>
      </div>
      {purchaseOrder && (
        <div className="m-8">
          <IsolatedPurchaseOrderControl
            purchaseOrder={purchaseOrder}
            onPreviewPurchaseOrderClick={() =>
              history.push(`/purchaseorders/${purchaseOrderId}`)
            }
          />
        </div>
      )}
    </AuthenticatedPageWrapper>
  );
};
export default EditIsolatedPurchaseOrderPage;
